export const serviceDetailData = {
  "servicenow-consulting": {
    id: 1,
    step: "01",
    title: "ServiceNow Consulting",
    tagline: "Build the right ServiceNow strategy before you build the solution",
    subheadline: "Every ServiceNow journey starts with understanding your business, technology landscape and transformation objectives.",
    overview: "Our consulting team helps organizations assess their existing ServiceNow environment, identify process gaps, define the right platform strategy and create a practical roadmap for implementation and optimization.",
    capabilitiesTitle: "Our consulting services include:",
    capabilities: [
      "ServiceNow maturity and platform assessment",
      "Business process assessment",
      "ServiceNow roadmap and transformation strategy",
      "Platform architecture and solution design",
      "Process optimization",
      "Module selection and implementation planning",
      "Governance and platform strategy",
      "ServiceNow health checks",
      "Upgrade and modernization planning",
      "AI and automation opportunity assessment"
    ],
    outcome: "A clear, scalable ServiceNow roadmap aligned with business priorities.",
    badge: "Strategic Advisory",
    seo: {
      metaTitle: "ServiceNow Consulting Services & Roadmap Advisory | Mobikode",
      metaDescription: "Accelerate your digital transformation with certified ServiceNow consulting, platform maturity assessment, architecture design, and strategic roadmapping.",
      keywords: "ServiceNow consulting, ServiceNow maturity assessment, ServiceNow transformation strategy, ServiceNow platform architecture, IT process optimization"
    }
  },
  "servicenow-implementation": {
    id: 2,
    step: "02",
    title: "ServiceNow Implementation",
    tagline: "From platform setup to enterprise-wide transformation",
    subheadline: "Mobikode delivers end-to-end ServiceNow implementations designed around your business processes rather than forcing your organization into rigid workflows.",
    overview: "Our team can support the complete implementation lifecycle—from discovery and architecture through configuration, customization, integrations, testing, deployment and adoption.",
    capabilitiesTitle: "Implementation capabilities include:",
    capabilities: [
      "ServiceNow platform implementation",
      "Module configuration",
      "Workflow development",
      "Custom application development",
      "Business rules and scripting",
      "Service portal development",
      "Employee experience solutions",
      "Forms and catalog configuration",
      "Approval workflows",
      "Notifications and automation",
      "Data migration",
      "Third-party integrations",
      "Testing and deployment",
      "User adoption and training"
    ],
    outcome: "Rapid, zero-disruption platform deployment built to scale with your operational demands.",
    badge: "Core Implementation",
    seo: {
      metaTitle: "ServiceNow Implementation & Deployment Services | Mobikode",
      metaDescription: "Enterprise-grade ServiceNow implementation, module setup, workflow automation, and custom app development for seamless enterprise rollout.",
      keywords: "ServiceNow implementation, ServiceNow deployment, workflow development, ServiceNow portal development, ServiceNow data migration"
    }
  },
  "servicenow-itsm": {
    id: 3,
    step: "03",
    title: "ServiceNow ITSM",
    tagline: "Modernize IT service delivery",
    subheadline: "Transform traditional IT support into an intelligent, automated and employee-centric service experience.",
    overview: "Mobikode helps organizations implement and optimize ITSM processes to improve service quality, reduce resolution times and increase IT productivity.",
    capabilitiesTitle: "ITSM capabilities include:",
    capabilities: [
      "Incident Management",
      "Problem Management",
      "Change Management",
      "Request Management",
      "Service Catalog",
      "Knowledge Management",
      "Service Level Management",
      "Configuration Management",
      "Major Incident Management",
      "IT Operations integration",
      "Self-service portals",
      "Automated workflows"
    ],
    outcome: "High SLA compliance, rapid ticket turnaround, and intelligent IT self-service.",
    badge: "IT Service Excellence",
    seo: {
      metaTitle: "ServiceNow ITSM Implementation & Modernization | Mobikode",
      metaDescription: "Modernize IT service delivery with ServiceNow ITSM. Automate incident, problem, and change management workflows for higher productivity.",
      keywords: "ServiceNow ITSM, IT service management, incident management, change management ServiceNow, service catalog setup"
    }
  },
  "servicenow-itom-cmdb": {
    id: 4,
    step: "04",
    title: "ServiceNow ITOM & CMDB",
    tagline: "Gain complete visibility across your IT environment",
    subheadline: "Mobikode helps enterprises create a connected view of infrastructure, applications, services and dependencies using ServiceNow ITOM capabilities.",
    overview: "We help organizations improve operational visibility, identify service dependencies and build a reliable foundation for proactive IT management.",
    capabilitiesTitle: "Our capabilities include:",
    capabilities: [
      "CMDB implementation and optimization",
      "Discovery",
      "Service Mapping",
      "Infrastructure visibility",
      "Application dependency mapping",
      "Event Management",
      "Operational intelligence",
      "Configuration governance",
      "Service health monitoring",
      "Cloud infrastructure visibility"
    ],
    outcome: "Proactive event management, single source of infrastructure truth, and reduced service downtime.",
    badge: "Operations Intelligence",
    seo: {
      metaTitle: "ServiceNow ITOM & CMDB Configuration Services | Mobikode",
      metaDescription: "Gain 360-degree IT infrastructure visibility with ServiceNow ITOM and CMDB optimization, Discovery, Service Mapping, and Event Management.",
      keywords: "ServiceNow ITOM, CMDB optimization, ServiceNow Discovery, Service Mapping, Event Management ServiceNow"
    }
  },
  "servicenow-csm": {
    id: 5,
    step: "05",
    title: "ServiceNow CSM",
    tagline: "Deliver connected and intelligent customer service",
    subheadline: "Create a unified customer service experience by connecting customer-facing teams with the processes and systems behind them.",
    overview: "Mobikode helps organizations streamline case management, automate service workflows and provide customers with faster access to information and support.",
    capabilitiesTitle: "Our CSM capabilities include:",
    capabilities: [
      "Case Management",
      "Customer self-service",
      "Customer portals",
      "Knowledge Management",
      "Omnichannel support",
      "Workflow automation",
      "Customer communications",
      "SLA management",
      "Customer service analytics",
      "Integration with enterprise systems"
    ],
    outcome: "Frictionless customer journeys, reduced resolution time, and heightened customer satisfaction scores.",
    badge: "Customer Engagement",
    seo: {
      metaTitle: "ServiceNow CSM Implementation & Customer Service | Mobikode",
      metaDescription: "Connect front and back-office teams with ServiceNow Customer Service Management (CSM) for omnichannel workflows and reduced resolution time.",
      keywords: "ServiceNow CSM, customer service management, ServiceNow customer portal, case management automation, omnichannel customer support"
    }
  },
  "servicenow-hrsd": {
    id: 6,
    step: "06",
    title: "ServiceNow HRSD",
    tagline: "Create better employee experiences",
    subheadline: "Modern HR requires more than processing requests. Mobikode helps organizations create connected employee experiences through digital HR workflows, self-service and automation.",
    overview: "We deliver streamlined, consumer-grade digital HR service centers that empower employees from day one and reduce administrative burdens.",
    capabilitiesTitle: "Our HRSD capabilities include:",
    capabilities: [
      "Employee Center",
      "HR Case Management",
      "Employee workflows",
      "HR Service Delivery",
      "Employee self-service",
      "Knowledge management",
      "HR request automation",
      "Employee onboarding workflows",
      "HR system integrations",
      "Employee experience optimization"
    ],
    outcome: "Automated onboarding, self-serve HR efficiency, and maximized employee retention.",
    badge: "Employee Experience",
    seo: {
      metaTitle: "ServiceNow HRSD & Digital Employee Experience | Mobikode",
      metaDescription: "Transform employee journeys with ServiceNow HR Service Delivery (HRSD), unified Employee Center, automated onboarding, and self-service HR.",
      keywords: "ServiceNow HRSD, HR service delivery, ServiceNow Employee Center, digital HR onboarding, HR case management"
    }
  },
  "servicenow-ai-automation": {
    id: 7,
    step: "07",
    title: "ServiceNow Automation & AI",
    tagline: "Make enterprise workflows intelligent",
    subheadline: "Mobikode combines ServiceNow with AI, automation and enterprise integrations to reduce manual work and accelerate business processes.",
    overview: "We identify repetitive and rule-based activities and transform them into intelligent, automated workflows. The goal is simple: less manual effort, faster decisions and more intelligent operations.",
    capabilitiesTitle: "Our capabilities include:",
    capabilities: [
      "Workflow automation",
      "Flow Designer",
      "Integration Hub",
      "AI-powered workflows",
      "Generative AI use cases",
      "Virtual Agent",
      "Intelligent recommendations",
      "Automated approvals",
      "Automated task routing",
      "Document and data automation",
      "Cross-platform orchestration",
      "Enterprise system integrations"
    ],
    outcome: "Elimination of repetitive manual processes and rapid, automated decision-making.",
    badge: "Intelligent Automation",
    seo: {
      metaTitle: "ServiceNow AI & Intelligent Automation Services | Mobikode",
      metaDescription: "Embed Generative AI, Now Assist, Flow Designer, and Virtual Agents into your ServiceNow enterprise workflows for accelerated decision-making.",
      keywords: "ServiceNow AI, Now Assist, ServiceNow automation, Flow Designer, ServiceNow Virtual Agent, Generative AI ServiceNow"
    }
  },
  "servicenow-integration": {
    id: 8,
    step: "08",
    title: "ServiceNow Integration",
    tagline: "Connect ServiceNow with your enterprise ecosystem",
    subheadline: "ServiceNow becomes significantly more powerful when it works seamlessly with the rest of your technology environment.",
    overview: "Mobikode helps integrate ServiceNow with enterprise applications, cloud platforms, business systems and third-party services.",
    capabilitiesTitle: "Integration capabilities include:",
    capabilities: [
      "REST & SOAP integrations",
      "API integrations",
      "Integration Hub",
      "ERP integrations",
      "CRM integrations",
      "HR system integrations",
      "Identity and access integrations",
      "Cloud integrations",
      "Data synchronization",
      "Custom middleware integrations",
      "Third-party application integrations"
    ],
    outcome: "A fully unified, bidirectional data stream across your entire enterprise software stack.",
    badge: "Enterprise Connectivity",
    seo: {
      metaTitle: "ServiceNow Integration Services & API Solutions | Mobikode",
      metaDescription: "Seamless bidirectional integrations connecting ServiceNow with ERPs, CRMs, cloud platforms, and custom legacy systems using Integration Hub.",
      keywords: "ServiceNow Integration Hub, ServiceNow REST API, ServiceNow ERP integration, ServiceNow third-party integration, data synchronization"
    }
  },
  "servicenow-custom-development": {
    id: 9,
    step: "09",
    title: "ServiceNow Custom Application Development",
    tagline: "Build applications around your unique business processes",
    subheadline: "Not every enterprise process fits into an out-of-the-box ServiceNow module.",
    overview: "Mobikode develops scalable custom applications and workflows on the ServiceNow platform to address specialized business requirements.",
    capabilitiesTitle: "Capabilities include:",
    capabilities: [
      "Custom applications",
      "Custom tables and data models",
      "Business rules",
      "Script development",
      "UI policies and actions",
      "Custom workflows",
      "Workspace development",
      "Service portals",
      "Custom dashboards",
      "Application integrations",
      "Low-code / no-code solutions"
    ],
    outcome: "Tailored enterprise tools designed specifically around your proprietary operational models.",
    badge: "Custom Engineering",
    seo: {
      metaTitle: "ServiceNow Custom Application Development | Mobikode",
      metaDescription: "Build bespoke enterprise tools, custom portals, and tailored business rules on ServiceNow using App Engine and modern web architectures.",
      keywords: "ServiceNow custom app development, ServiceNow App Engine, ServiceNow scripting, custom portal development, ServiceNow low-code"
    }
  },
  "servicenow-managed-services": {
    id: 10,
    step: "10",
    title: "ServiceNow Support & Managed Services",
    tagline: "Keep your ServiceNow platform optimized beyond go-live",
    subheadline: "ServiceNow transformation doesn't end after implementation.",
    overview: "Mobikode provides ongoing support, maintenance and managed services to help organizations maintain platform performance, resolve issues, implement enhancements and continuously improve their ServiceNow environment.",
    capabilitiesTitle: "Our managed services include:",
    capabilities: [
      "L1/L2/L3 ServiceNow support",
      "Incident resolution",
      "Platform monitoring",
      "Performance optimization",
      "ServiceNow upgrades",
      "Bug fixing",
      "Enhancement development",
      "Workflow optimization",
      "Integration support",
      "CMDB maintenance",
      "Security and access management",
      "Release management",
      "Platform health checks",
      "Continuous improvement"
    ],
    outcome: "Guaranteed uptime, zero technical debt backlog, and proactive continuous platform evolution.",
    badge: "24/7 Managed Operations",
    seo: {
      metaTitle: "24/7 ServiceNow Managed Services & Platform Support | Mobikode",
      metaDescription: "Reliable L1-L3 ServiceNow managed services, release upgrades, platform health checks, and continuous performance tuning.",
      keywords: "ServiceNow managed services, ServiceNow support L1 L2 L3, ServiceNow release upgrades, ServiceNow maintenance, platform health check"
    }
  },
  "servicenow-resource-augmentation": {
    id: 11,
    step: "11",
    title: "ServiceNow Resource Augmentation",
    tagline: "Extend your ServiceNow team with experienced specialists",
    subheadline: "Whether you need additional developers for a specific project or an experienced architect to strengthen your internal team, Mobikode provides flexible ServiceNow resource models.",
    overview: "Engagement models can include individual certified resources, dedicated engineering pods, or project-based delivery teams tailored to your deployment timeline.",
    capabilitiesTitle: "Access specialized professionals including:",
    capabilities: [
      "ServiceNow Architects",
      "ServiceNow Consultants",
      "ServiceNow Developers",
      "Business Analysts",
      "Integration Specialists",
      "ITSM Consultants",
      "ITOM Specialists",
      "QA Engineers",
      "ServiceNow Administrators",
      "Project Managers"
    ],
    outcome: "Instant scale-up of certified technical bandwidth without lengthy hiring cycles.",
    badge: "On-Demand Expertise",
    seo: {
      metaTitle: "ServiceNow Resource Augmentation & Staff Augmentation | Mobikode",
      metaDescription: "Hire certified ServiceNow architects, developers, and dedicated delivery pods on-demand with flexible staffing models.",
      keywords: "ServiceNow resource augmentation, hire ServiceNow developers, ServiceNow certified architects, ServiceNow staff augmentation, dedicated ServiceNow pod"
    }
  },
  "servicenow-coe": {

    id: 12,

    step: "12",

    title: "ServiceNow Center of Excellence (COE)",

    tagline: "Build a stronger, scalable, and governed ServiceNow ecosystem",

    subheadline: "Mobikode helps organizations establish and strengthen a ServiceNow Center of Excellence with the right governance, standards, processes, and expertise to maximize the value of their ServiceNow platform.",

    overview: "Our ServiceNow COE approach brings together platform governance, standardization, continuous improvement, innovation, and adoption into a structured framework. Whether you are establishing a new COE or optimizing an existing one, we help create a scalable foundation aligned with your business goals.",

    capabilitiesTitle: "Our ServiceNow COE capabilities include:",

    capabilities: [

        "ServiceNow COE Strategy & Roadmap",

        "Platform Governance",

        "ServiceNow Best Practices",

        "Platform Standardization",

        "Process & Workflow Optimization",

        "ServiceNow Architecture Governance",

        "Continuous Improvement",

        "ServiceNow Platform Adoption",

        "Innovation & Automation",

        "Performance & KPI Management"

    ],

    outcome: "A structured and scalable ServiceNow ecosystem with stronger governance, consistent processes, faster adoption, and continuous platform improvement.",

    badge: "ServiceNow Excellence",

    seo: {

        metaTitle: "ServiceNow Center of Excellence (COE) Services | Mobikode",

        metaDescription: "Build and scale a ServiceNow Center of Excellence with Mobikode's COE services covering governance, standardization, platform optimization, innovation, adoption, and continuous improvement.",

        keywords: "ServiceNow Center of Excellence, ServiceNow COE, ServiceNow COE Services, ServiceNow COE Consulting, ServiceNow Governance, ServiceNow Platform Governance, ServiceNow Strategy, ServiceNow Best Practices, ServiceNow Platform Standardization, ServiceNow Continuous Improvement, ServiceNow Innovation, ServiceNow Adoption, ServiceNow Platform Optimization"

    }

}
};